import { Alert, Box, Divider, Stack, Typography, alpha } from '@mui/material';
import {
    Info as InfoIcon,
    Link as LinkIcon,
    Add as AddIcon,
    Warning as WarningIcon,
} from '@mui/icons-material';

const InstructionsPanel: React.FC = () => {
    return (
        <Box
            sx={{
                width: 280,
                flexShrink: 0,
                bgcolor: alpha('#1976d2', 0.03),
                borderRight: '1px solid',
                borderColor: 'divider',
                p: 2,
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                    width: 6,
                },
                '&::-webkit-scrollbar-track': {
                    bgcolor: 'grey.100',
                    borderRadius: 3,
                },
                '&::-webkit-scrollbar-thumb': {
                    bgcolor: 'grey.400',
                    borderRadius: 3,
                    '&:hover': {
                        bgcolor: 'grey.500',
                    },
                },
            }}>
            <Stack spacing={2}>
                <Alert
                    severity="error"
                    icon={<WarningIcon fontSize="small" />}
                    sx={{
                        py: 0.5,
                        '& .MuiAlert-message': { fontSize: '0.75rem' },
                    }}>
                    Do not refresh the page before confirming your decision. Your document
                    processing will be paused until you complete this review.
                </Alert>

                <Stack direction="row" alignItems="center" spacing={1}>
                    <InfoIcon color="primary" fontSize="small" />
                    <Typography variant="subtitle2" fontWeight="bold" color="primary">
                        How to use this dialog
                    </Typography>
                </Stack>

                <Box>
                    <Typography
                        variant="caption"
                        fontWeight="bold"
                        color="text.secondary"
                        sx={{ display: 'block', mb: 0.5 }}>
                        What is this?
                    </Typography>
                    <Typography variant="body2" fontSize="0.8rem" color="text.secondary">
                        We found a stock item name in your document that doesn't exactly match
                        any existing stock item in your master data.
                    </Typography>
                </Box>

                <Divider />

                <Box>
                    <Typography
                        variant="caption"
                        fontWeight="bold"
                        color="text.secondary"
                        sx={{ display: 'block', mb: 0.5 }}>
                        <LinkIcon sx={{ fontSize: 14, mr: 0.5, verticalAlign: 'middle' }} />
                        Map to Existing
                    </Typography>
                    <Typography variant="body2" fontSize="0.8rem" color="text.secondary">
                        Select this if the extracted stock item is the same as an existing
                        item but with a different name variation. Use the search box or
                        click on an item from the list.
                    </Typography>
                </Box>

                <Box>
                    <Typography
                        variant="caption"
                        fontWeight="bold"
                        color="text.secondary"
                        sx={{ display: 'block', mb: 0.5 }}>
                        <AddIcon
                            sx={{ fontSize: 14, mr: 0.5, verticalAlign: 'middle' }}
                        />
                        Create New Stock Item
                    </Typography>
                    <Typography variant="body2" fontSize="0.8rem" color="text.secondary">
                        Select this if this is a completely new stock item that should be added
                        to your stock master.
                    </Typography>
                </Box>

                <Divider />

                <Alert
                    severity="warning"
                    icon={<WarningIcon fontSize="small" />}
                    sx={{
                        py: 0.5,
                        '& .MuiAlert-message': { fontSize: '0.75rem' },
                    }}>
                    Clicking Cancel will automatically create a new stock item entry.
                </Alert>
            </Stack>
        </Box>
    );
};

export default InstructionsPanel;
